// extracted by mini-css-extract-plugin
module.exports = {"header":"e_no","gallery":"e_oo","label":"e_po"};